import { MouseEventHandler } from 'react'

import { useIsMobile } from 'hooks/useIsMobile'
import { SpotlightPageBanner } from 'interfaces/types'

import { StyledBannerContainer } from './index.styled'
export type Props = {
  className?: string
  banner: SpotlightPageBanner
  bannerUrl?: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
}

const LandingPageBanner = ({ banner, className, onClick }: Props) => {
  const isMobile = useIsMobile()
  if (isMobile && !banner?.mobile) return null
  if (!isMobile && !banner?.desktop) return null

  return (
    <StyledBannerContainer
      className={className}
      href={banner?.url}
      onClick={banner?.url ? undefined : onClick}
      target={banner?.url ? '_blank' : undefined}
      enableScroll={!banner?.url && typeof onClick !== 'undefined'}
    >
      <img
        src={isMobile ? banner?.mobile : banner?.desktop}
        alt="banner"
        loading="lazy"
      />
    </StyledBannerContainer>
  )
}

export { LandingPageBanner }
